import { Editor } from 'slate';
export function isInList(editor) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.selection;

  if (!location) {
    return false;
  }

  for (var [currentNode] of Editor.levels(editor, {
    at: location
  })) {
    if (editor.isListNode(currentNode)) {
      return true;
    }
  }

  return false;
}